import { IChatMessage } from './chat.interfaces';

export async function fileToChatMessages(id: string, file: File): Promise<IChatMessage[]> {
    const file_parts = [];
    const chunkSize = 1024 * 256;
    const dataURI = (await getBase64(file)) as any;
    const size = 4 * Math.ceil(dataURI.length / 3);
    const chunks = Math.ceil(size / chunkSize);
    const chunkLength = Math.ceil((chunkSize * 3) / 4);
    let chunk = 0;
    while (chunk < chunks) {
        const offset = chunk * chunkLength;
        const text = dataURI.slice(offset, offset + chunkLength);
        file_parts.push({
            file_name: `${file.name}`,
            file_part: chunk,
            total_parts: chunks,
            meeting_id: id,
            text: text,
            type: 'message',
            style: 'file',
        });
        chunk++;
    }
    return file_parts;
}

export function getBase64(file: File): Promise<string | ArrayBuffer> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

export function dataURItoBlob(dataURI: string) {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    let byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    let ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    let ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    let blob = new Blob([ab], { type: mimeString });
    return blob;
}

export async function b64toBlob(url: string): Promise<Blob> {
    const response = await fetch(url);
    return response.blob();
}
